'use strict';

/**
 * @param {number} number
 * @returns {Uint8Array}
 */
var fromNumberTo32BitBuf = function fromNumberTo32BitBuf(number) {
  var bytes = new Uint8Array(4);
  for (var i = 0; i < 4; i++) {
    bytes[i] = number & 0xff;
    number = number >> 8;
  }
  return bytes;
};
module.exports = {
  fromNumberTo32BitBuf: fromNumberTo32BitBuf
};